module.exports = __webpack_public_path__ + "static/media/google.41802a94.png";